import '../sass/testimonials.scss';

(() => {
    const swiperScript = document.querySelector('#ofg-education-swiper-js');
    const $blocks = document.querySelectorAll('.block.testimonials');

    if (!$blocks) return;

    $blocks.forEach($block => {
        const $carouselPagination = $block.querySelector('.testimonials__pagination');
        const $carousel = $block.querySelector('.testimonials__carousel');

        const initCarousel = () => {
            if (!$carousel) return;

            new Swiper($carousel, {
                pagination: {
                    el: $carouselPagination,
                    clickable: true,
                },
                loop: true,
                keyboard: {
                    enabled: true,
                    onlyInViewport: true,
                },
                autoplay: {
                    delay: 7000
                }
            });
        };

        if (typeof Swiper !== 'undefined') {
            initCarousel();
        } else if (swiperScript) {
            swiperScript.addEventListener('load', () => {
                initCarousel();
            });
        } else {
            window.addEventListener('load', () => {
                const swiperScript = document.querySelector('#ofg-education-swiper-js');

                if (!swiperScript) return;

                initCarousel();
            });
        }
    });
})();
